import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import CoursePlan1 from './components/CoursePlans/CoursePlan1';
import CoursePlan2 from './components/CoursePlans/CoursePlan2';
import CoursePlan3 from './components/CoursePlans/CoursePlan3';
import CoursePlan4 from './components/CoursePlans/CoursePlan4';
import Registration1 from './components/Registrations/Registration1';
import Registration2 from './components/Registrations/Registration2';
import Registration3 from './components/Registrations/Registration3';
import Registration4 from './components/Registrations/Registration4';
import Home from './Home';

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<Home />} />
        <Route path="/course-plan-1" element={<CoursePlan1 />} />
        <Route path="/course-plan-2" element={<CoursePlan2 />} />
        <Route path="/course-plan-3" element={<CoursePlan3 />} />
        <Route path="/course-plan-4" element={<CoursePlan4 />} />
        <Route path="/registration-1" element={<Registration1 />} />
        <Route path="/registration-2" element={<Registration2 />} />
        <Route path="/registration-3" element={<Registration3 />} />
        <Route path="/registration-4" element={<Registration4 />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;